import React, { useState, useEffect, createContext } from 'react';
import { BASELINE } from '../util';
import axios from 'axios';

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [err, setErr] = useState('');
  const [aiid, setaiid] = useState('');

  useEffect(() => {
    getUserLoginState();
  }, []);

  const clearLocalStorageExceptUser = () => {
    const userId = localStorage.getItem("quiz-loggedinuserid");
    const isAuth = localStorage.getItem("isAuthenticated");
    localStorage.clear();
    // Only restore if there is a real user ID (not the "null" string)
    if (userId && userId !== "null") {
      localStorage.setItem("quiz-loggedinuserid", userId);
      localStorage.setItem("isAuthenticated", isAuth);
    }
  }

  const getUserLoginState = async () => {
    let u_id = localStorage.getItem("quiz-loggedinuserid");
    if (u_id && u_id !== "null") {
      try {
        const res = await axios.post(BASELINE + 'user/info', { u_id });
        if (res.status === 200) {
          let fetchedUser = res.data;
          // Check if the user's premium end date has passed
          const currentDate = new Date();
          const endPremiumDate = new Date(fetchedUser.end_premium_date);
          if (fetchedUser.premium && endPremiumDate < currentDate) {
            // Set premium to false if the date has passed
            fetchedUser.premium = 0;
            setUser(fetchedUser);
            // Update server with new premium status
            await updatePremiumStatus(u_id, 0);
          } else {
            setUser(fetchedUser);
          }
        } else {
          setErr('Error connecting to server');
        }
      } catch (error) {
        setErr('Error fetching user info');
      }
    }
  };

  const updatePremiumStatus = async (u_id, newPremiumStatus) => {
    try {
      await axios.post(BASELINE + 'user/update-premium-status', {
        u_id,
        premium: newPremiumStatus,
      });
    } catch (error) {
      // 오류 처리
    }
  };

  const logoutUser = () => {
    localStorage.removeItem("quiz-loggedinuserid"); // setItem(null) stores "null" string which is truthy
    localStorage.setItem("isAuthenticated", "false");
    localStorage.removeItem("quiz-email");
    localStorage.removeItem("quiz-password");
    localStorage.removeItem("currentTest"); // clear any in-progress test autosave
    setUser(null);
  };

  const savelogin = (value) => {
    localStorage.setItem("quiz-loggedinuserid", value.u_id);
    setUser(value);
  };

  // 회원가입 시 사용자의 이메일과 비밀번호를 로컬 스토리지에 저장하는 함수
  const saveCredentials = (email, password) => {
    localStorage.setItem("quiz-email", email);
    localStorage.setItem("quiz-password", password);
  };

  const setid = (id) => {
    setaiid(id);
  };

  return (
    <UserContext.Provider value={{ aiid, user, logoutUser, savelogin, setid, saveCredentials, clearLocalStorageExceptUser }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
